import React, { Component } from 'react';
import { Search } from 'semantic-ui-react';
import { string, bool, arrayOf, shape, func } from 'prop-types';

import generateResults from './generateResults';

class SearchField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: ''
    };
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  handleSearchChange = function handleSeachInputEvent(e) {
    this.setState({ searchTerm: e.target.value });
  };

  render() {
    const { searchTerm } = this.state;
    const {
      terms,
      genres,
      stations,
      match,
      loadingGenres,
      loadingStations,
      showModal
    } = this.props;
    const results = generateResults(
      searchTerm,
      genres,
      stations,
      terms,
      match,
      showModal
    );
    const loading = loadingGenres && loadingStations;
    return (
      <Search
        category
        fluid
        loading={loading}
        onSearchChange={e => this.handleSearchChange(e)}
        results={results}
        value={searchTerm}
      />
    );
  }
}

SearchField.propTypes = {
  terms: arrayOf(string).isRequired,
  loadingGenres: bool.isRequired,
  loadingStations: bool.isRequired,
  genres: arrayOf(shape).isRequired,
  stations: arrayOf(shape).isRequired,
  match: shape().isRequired,
  showModal: func.isRequired
};

export default SearchField;
